import { render, staticRenderFns } from "./LoginOtp.vue?vue&type=template&id=24f7db5a&scoped=true"
import script from "./LoginOtp.vue?vue&type=script&lang=js"
export * from "./LoginOtp.vue?vue&type=script&lang=js"
import style0 from "./LoginOtp.vue?vue&type=style&index=0&id=24f7db5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f7db5a",
  null
  
)

export default component.exports